import React from "react";
import { GiftIcon, CheckIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { FlowSteps } from "../FlowSteps";
import { CTAButton } from "../CTAButton";
import { bonuses } from "../../data/bonuses";
export function BonusesSection() {
  return <section className="bg-cream px-5 py-16 sm:py-24" data-id="element-112" data-mp="vbk8ub6ig3vw">
      <SectionHeading kicker="Exclusive bonuses" title={<>
            Today, I'm also giving you these <em className="text-coral" data-id="element-114" data-mp="1j3r231gxvur3">5 bonuses free</em>
          </>} subtitle={<>
            Reference value: <span className="font-bold text-ink line-through decoration-coral decoration-2" data-id="element-115" data-mp="19c4tzdzwebsk">$147</span> — included FREE with your purchase.
          </>} data-id="element-113" data-mp="vcc2vhkgltk2" />

      <div className="mx-auto mt-12 max-w-5xl space-y-16 sm:space-y-20" data-id="element-116" data-mp="1e8bqkg6emaxu">
        {bonuses.map((b, i) => <article key={b.number} className="grid items-center gap-8 lg:grid-cols-2 lg:gap-12" data-id="element-117" data-mp="26qz6ziagh1sl" data-mpi={i}>
            <div className={`-mx-5 sm:mx-0 ${i % 2 === 1 ? "lg:order-2" : ""}`} data-id="element-118" data-mp="2m5iekkixqda1">
              <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="w-full" loading="lazy" data-id="element-119" data-mp="2m3edeacf7sdg" />
            </div>
            <div data-id="element-120" data-mp="2vv1xtrak895f">
              <div className="flex flex-wrap items-center gap-2" data-id="element-121" data-mp="2vvk31df79xph">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-coral px-3 py-1 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-122" data-mp="2vx4uuva4r2jn">
                  <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-123" data-mp="34uf8uoec15s9" />
                  Bonus #{b.number}
                </span>
                <span className="text-sm font-semibold text-ink/70" data-id="element-124" data-mp="2zz00gbz3g238">
                  Value <span className="line-through" data-id="element-125" data-mp="3eto0halq68bg">{b.value}</span> · <strong className="text-brand" data-id="element-126" data-mp="39vcqmzvfjxt8">FREE today</strong>
                </span>
              </div>
              <h3 className="mt-4 font-serif text-3xl font-extrabold leading-tight text-ink" data-id="element-127" data-mp="1kfn2st1wvrcy">{b.title}</h3>
              {b.description.map(p => <p key={p} className="mt-3 text-[17px] leading-relaxed text-ink/80" data-id="element-128" data-mp="1fiwlk2edeppy">{p}</p>)}

              {b.flow && <>
                  <p className="mt-6 text-sm font-extrabold uppercase tracking-wider text-brand" data-id="element-129" data-mp="296160ki8q2v6">{b.flowLabel}:</p>
                  <FlowSteps steps={b.flow} className="mt-3" data-id="element-130" data-mp="2e54b24y80935" />
                </>}

              {b.items && <>
                  <p className="mt-6 text-sm font-extrabold uppercase tracking-wider text-brand" data-id="element-131" data-mp="2o41vowsizigv">{b.listLabel}:</p>
                  <ul className="mt-3 flex flex-wrap gap-2" data-id="element-132" data-mp="2s5f3hcf6hvqf">
                    {b.items.map(item => <li key={item} className="flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-[15px] font-medium text-ink ring-1 ring-ink/10" data-id="element-133" data-mp="2wvvi2zuqjned">
                        <CheckIcon className="h-4 w-4 text-brand" strokeWidth={3} aria-hidden="true" data-id="element-134" data-mp="31xb1knh9llun" />
                        {item}
                      </li>)}
                  </ul>
                </>}

              {b.closing.map(p => <p key={p} className="mt-6 font-serif text-xl font-bold italic text-brand" data-id="element-135" data-mp="107lyza6tddum">{p}</p>)}
            </div>
          </article>)}
      </div>

      <CTAButton label="Yes! Give me all 5 bonuses free" className="mt-16" data-id="element-136" data-mp="q96734zyq0k2" />
    </section>;
}